import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Login = () => import('@/views/Login')
const ConfirmAccount = () => import('@/views/ConfirmAccount')

const Occurences = () => import('@/views/Occurences/OccurencesList')
const OccurencesAdd = () => import('@/views/Occurences/OccurencesAdd')
const OccurencesEdit = () => import('@/views/Occurences/OccurencesEdit')

const Users = () => import('@/views/Users/UsersList')
const StartInfos = () => import('@/views/StartInfos/StartInfosList')
const StartInfosAdd = () => import('@/views/StartInfos/StartInfosAdd')
const StartInfosEdit = () => import('@/views/StartInfos/StartInfosEdit')

 const Rankings = () => import('@/views/Rankings')

const KeyValues = () => import('@/views/KeyValues/KeyValuesList')
const KeyValuesAdd = () => import('@/views/KeyValues/KeyValuesAdd')
const KeyValuesEdit = () => import('@/views/KeyValues/KeyValuesEdit')

const StaticInfos = () => import('@/views/StaticInfos/StaticInfosList')
const StaticInfosAdd = () => import('@/views/StaticInfos/StaticInfosAdd')
const StaticInfosEdit = () => import('@/views/StaticInfos/StaticInfosEdit')

const Profile = () => import('@/views/Profile')
const Page404 = () => import('@/views/Page404')
const Page500 = () => import('@/views/Page500')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/occurences',
      name: 'Occurences',
      component: TheContainer,
      children: [
        // Occurences
        {
          path: 'occurences',
          redirect: '/occurences/list',
          name: 'Occurences',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'OccurencesList',
              component: Occurences
            },
            {
              path: 'add',
              name: 'OccurencesAdd',
              component: OccurencesAdd
            },
            {
              path: 'edit',
              name: 'OccurencesEdit',
              component: OccurencesEdit
            },
          ]
        },
        // Users
        {
          path: 'users',
          redirect: '/users/list',
          name: 'Users',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'UsersList',
              component: Users
            },
          ]
        },
        // StartInfos
        {
          path: 'startInfos',
          redirect: '/startInfos/list',
          name: 'StartInfos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'StartInfosList',
              component: StartInfos
            },
            {
              path: 'add',
              name: 'StartInfosAdd',
              component: StartInfosAdd
            },
            {
              path: 'edit',
              name: 'StartInfosEdit',
              component: StartInfosEdit
            },
          ]
        },
        // KeyValues
        {
          path: 'infos',
          redirect: '/infos/list',
          name: 'KeyValues',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'KeyValuesList',
              component: KeyValues
            },
            {
              path: 'add',
              name: 'KeyValuesAdd',
              component: KeyValuesAdd
            },
            {
              path: 'edit',
              name: 'KeyValuesEdit',
              component: KeyValuesEdit
            },
          ]
        },
        // StaticInfos
        {
          path: 'pages',
          redirect: '/pages/list',
          name: 'StaticInfos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'StaticInfosList',
              component: StaticInfos
            },
            {
              path: 'add',
              name: 'StaticInfosAdd',
              component: StaticInfosAdd
            },
            {
              path: 'edit',
              name: 'StaticInfosEdit',
              component: StaticInfosEdit
            },
          ]
        },
        // Profile
        {
          path: 'profile',
          name: 'Profile',
          component: Profile
        },
        // Ranking
        {
          path: '/rankings',
          name: 'Rankings',
          component: Rankings
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/confirm-account',
      name: 'ConfirmAccount',
      component: ConfirmAccount
    },
    {
      path: '/404',
      name: '404',
      component: Page404
    },    
    {
      path: '/500',
      name: '500',
      component: Page500
    }, 
  ]
}

